var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45557 12.8278C10.8488 12.8278 12.7889 10.8877 12.7889 8.49447C12.7889 6.10123 10.8488 4.16113 8.45557 4.16113C6.06233 4.16113 4.12223 6.10123 4.12223 8.49447C4.12223 10.8877 6.06233 12.8278 8.45557 12.8278Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2156 13.2538L13.1289 13.1671M13.1289 3.82048L13.2156 3.73382L13.1289 3.82048ZM3.69557 13.2538L3.78223 13.1671L3.69557 13.2538ZM8.45557 1.88048V1.82715V1.88048ZM8.45557 15.1605V15.1071V15.1605ZM1.84223 8.49382H1.7889H1.84223ZM15.1222 8.49382H15.0689H15.1222ZM3.78223 3.82048L3.69557 3.73382L3.78223 3.82048Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSun);
export default __webpack_public_path__ + "static/media/icon_sun.98ace309fbeda2ae27eea3ae57fd46e8.svg";
export { ForwardRef as ReactComponent };